import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Chip,
  Grid,
  Alert,
  useTheme,
  useMediaQuery,
  Paper,
  LinearProgress,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  InputAdornment
} from '@mui/material';
import {
  Close as CloseIcon,
  Save as SaveIcon,
  Add as AddIcon,
  CloudUpload as UploadIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  AudioFile as AudioIcon,
  Cancel as CancelIcon,
  // Ícones de plataforma
  Language as WebIcon,
  YouTube as YouTubeIcon,
  X as XIcon,
  Instagram as InstagramIcon,
  MusicNote as TikTokIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  Newspaper as NewspaperIcon,
  MenuBook as MagazineIcon,
  Tv as TvIcon,
  Radio as RadioIcon,
  Podcasts as PodcastIcon,
  DocumentScanner as OcrIcon,
  Article as ArticleIcon,
  PictureAsPdf as PdfIcon,
  // Ícones para navegação de páginas
  NavigateBefore as PrevIcon,
  NavigateNext as NextIcon,
  Delete as DeleteIcon,
  AddPhotoAlternate as AddPageIcon,
  Refresh as RefreshIcon,
  Clear as ClearIcon
} from '@mui/icons-material';
import ListItemIcon from '@mui/material/ListItemIcon';
import TagDialog from '../../../organisms/TagDialog';
import ImageCropDialog from '../ImageCropDialog';
import api from '../../../../services/api';
import { useViewSettings } from '../../../../context/ViewSettingsContext';
import { useTagSettings } from '../../../../context/TagSettingsContext';
import TagChip from '../../../atoms/TagChip';
import PlatformDialog from '../../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../../molecules/PlatformDialog/PlatformDialogTitle';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DatePickerCalendarHeader from '../../../molecules/DatePickerCalendarHeader/DatePickerCalendarHeader';
import { ptBR } from 'date-fns/locale';
import * as pdfjsLib from 'pdfjs-dist';

// Configurar worker do PDF.js - versão 3.x (estável)
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';

// Logo customizado do Threads (logo oficial da Meta)
const ThreadsIcon = ({ fontSize = 'small' }) => {
  const sizeMap = {
    small: 20,
    medium: 24,
    large: 28,
    inherit: 20
  };
  const size = typeof fontSize === 'number' ? fontSize : sizeMap[fontSize] || sizeMap.small;

  return (
    <svg
      viewBox="0 0 192 192"
      style={{
        width: size,
        height: size,
        fill: 'currentColor',
        display: 'inline-block',
        verticalAlign: 'middle'
      }}
    >
      <path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z" />
    </svg>
  );
};

// Logo customizado do Pinterest
const PinterestIcon = ({ fontSize = 'small' }) => {
  const sizeMap = {
    small: 20,
    medium: 24,
    large: 28,
    inherit: 20
  };
  const size = typeof fontSize === 'number' ? fontSize : sizeMap[fontSize] || sizeMap.small;

  return (
    <svg
      viewBox="0 0 24 24"
      style={{
        width: size,
        height: size,
        fill: 'currentColor',
        display: 'inline-block',
        verticalAlign: 'middle'
      }}
    >
      <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
    </svg>
  );
};

// Componente intermediário para seleção de plataforma e tipo
const MediaTypeSelector = ({ open, onClose, onConfirm, mode = 'create' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedMediaType, setSelectedMediaType] = useState('Online');
  const [selectedContentType, setSelectedContentType] = useState('article');

  // Mapeamento dinâmico: contentType baseado em mediaType
  const getContentTypeOptions = (mediaType) => {
    const options = {
      // Mídias Digitais
      YouTube: [
        { value: 'video', label: 'Vídeo' },
        { value: 'short', label: 'Short' }
      ],
      Twitter: [
        { value: 'tweet', label: 'Tweet' },
        { value: 'video', label: 'Vídeo' }
      ],
      Instagram: [
        { value: 'post', label: 'Post' },
        { value: 'reel', label: 'Reel' },
        { value: 'story', label: 'Stories' },
        { value: 'video', label: 'Vídeo' }
      ],
      TikTok: [
        { value: 'video', label: 'Vídeo' }
      ],
      Facebook: [
        { value: 'post', label: 'Post' },
        { value: 'reel', label: 'Reel' },
        { value: 'photo', label: 'Foto' },
        { value: 'story', label: 'Stories' },
        { value: 'video', label: 'Vídeo' }
      ],
      LinkedIn: [
        { value: 'post', label: 'Post' },
        { value: 'video', label: 'Vídeo' },
        { value: 'article', label: 'Artigo' }
      ],
      Threads: [
        { value: 'post', label: 'Post' },
        { value: 'video', label: 'Vídeo' }
      ],
      Pinterest: [
        { value: 'pin', label: 'Pin' },
        { value: 'video', label: 'Vídeo' }
      ],
      Online: [
        { value: 'article', label: 'Artigo' },
        { value: 'video', label: 'Vídeo' }
      ],
      // Mídias Impressas
      Jornal: [
        { value: 'article', label: 'Matéria' }
      ],
      Revista: [
        { value: 'article', label: 'Matéria' }
      ],
      // Mídias Eletrônicas
      TV: [
        { value: 'video', label: 'Matéria/Reportagem' }
      ],
      Radio: [
        { value: 'article', label: 'Menção/Inserção' }
      ],
      Podcast: [
        { value: 'article', label: 'Episódio' }
      ]
    };
    return options[mediaType] || options.Online;
  };

  // Handler especial para mediaType que reseta contentType
  const handleMediaTypeChange = (event) => {
    const newMediaType = event.target.value;
    const availableOptions = getContentTypeOptions(newMediaType);
    const defaultContentType = availableOptions[0]?.value || 'article';

    setSelectedMediaType(newMediaType);
    setSelectedContentType(defaultContentType);
  };

  const handleConfirm = () => {
    onConfirm({
      mediaType: selectedMediaType,
      contentType: selectedContentType
    });
    // Não chamar onClose() aqui - o handleMediaTypeConfirm já cuida de esconder o seletor
    // Chamar onClose() aqui causava o modal fechar completamente e resetar editedArticle
  };

  const handleCancel = () => {
    setSelectedMediaType('Online');
    setSelectedContentType('article');
    onClose();
  };

  return (
    <PlatformDialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <PlatformDialogTitle
        title={mode === 'create' ? 'Criar Novo Artigo' : 'Fazer Upload de Mídia'}
        icon={<AddIcon />}
        onClose={handleCancel}
      />
      <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
        <Typography variant={isMobile ? 'caption' : 'body2'} color="text.secondary" sx={{ mb: isMobile ? 2 : 3 }}>
          {mode === 'create'
            ? (isMobile ? 'Selecione a plataforma e tipo:' : 'Primeiro, selecione a plataforma e o tipo de conteúdo do artigo:')
            : (isMobile ? 'Selecione a plataforma e tipo:' : 'Primeiro, selecione a plataforma e o tipo de conteúdo da mídia que você vai fazer upload:')
          }
        </Typography>

        <Grid container spacing={isMobile ? 1.5 : 2}>
          <Grid item xs={12}>
            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
              <InputLabel id="mediaType-selector-label">Plataforma</InputLabel>
              <Select
                labelId="mediaType-selector-label"
                value={selectedMediaType}
                onChange={handleMediaTypeChange}
                label="Plataforma"
              >
                {/* Mídias Digitais */}
                <MenuItem value="Online"><ListItemIcon sx={{ minWidth: 32 }}><WebIcon fontSize="small" /></ListItemIcon>Online (Site)</MenuItem>
                <MenuItem value="YouTube"><ListItemIcon sx={{ minWidth: 32 }}><YouTubeIcon fontSize="small" /></ListItemIcon>YouTube</MenuItem>
                <MenuItem value="Twitter"><ListItemIcon sx={{ minWidth: 32 }}><XIcon fontSize="small" /></ListItemIcon>Twitter/X</MenuItem>
                <MenuItem value="Instagram"><ListItemIcon sx={{ minWidth: 32 }}><InstagramIcon fontSize="small" /></ListItemIcon>Instagram</MenuItem>
                <MenuItem value="TikTok"><ListItemIcon sx={{ minWidth: 32 }}><TikTokIcon fontSize="small" /></ListItemIcon>TikTok</MenuItem>
                <MenuItem value="Facebook"><ListItemIcon sx={{ minWidth: 32 }}><FacebookIcon fontSize="small" /></ListItemIcon>Facebook</MenuItem>
                <MenuItem value="LinkedIn"><ListItemIcon sx={{ minWidth: 32 }}><LinkedInIcon fontSize="small" /></ListItemIcon>LinkedIn</MenuItem>
                <MenuItem value="Pinterest"><ListItemIcon sx={{ minWidth: 32 }}><PinterestIcon fontSize="small" /></ListItemIcon>Pinterest</MenuItem>
                <MenuItem value="Threads"><ListItemIcon sx={{ minWidth: 32 }}><ThreadsIcon fontSize="small" /></ListItemIcon>Threads</MenuItem>
                {/* Mídias Impressas */}
                <MenuItem value="Jornal"><ListItemIcon sx={{ minWidth: 32 }}><NewspaperIcon fontSize="small" /></ListItemIcon>Jornal</MenuItem>
                <MenuItem value="Revista"><ListItemIcon sx={{ minWidth: 32 }}><MagazineIcon fontSize="small" /></ListItemIcon>Revista</MenuItem>
                {/* Mídias Eletrônicas */}
                <MenuItem value="TV"><ListItemIcon sx={{ minWidth: 32 }}><TvIcon fontSize="small" /></ListItemIcon>TV</MenuItem>
                <MenuItem value="Radio"><ListItemIcon sx={{ minWidth: 32 }}><RadioIcon fontSize="small" /></ListItemIcon>Rádio</MenuItem>
                <MenuItem value="Podcast"><ListItemIcon sx={{ minWidth: 32 }}><PodcastIcon fontSize="small" /></ListItemIcon>Podcast</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
              <InputLabel id="contentType-selector-label">Formato</InputLabel>
              <Select
                labelId="contentType-selector-label"
                value={selectedContentType}
                onChange={(e) => setSelectedContentType(e.target.value)}
                label="Formato"
              >
                {getContentTypeOptions(selectedMediaType).map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: isMobile ? 2 : 3, py: isMobile ? 1.5 : 2 }}>
        <Button onClick={handleCancel} color="inherit" size={isMobile ? 'small' : 'medium'}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} variant="contained" size={isMobile ? 'small' : 'medium'}>
          Continuar
        </Button>
      </DialogActions>
    </PlatformDialog>
  );
};

const ArticleEditModal = ({
  article,
  open,
  onClose,
  onSave,
  onSelectArticle,
  onAddTags,
  onRemoveTag,
  availableTags = [],
  mode = 'edit', // 'edit' ou 'create'
  initialMediaType, // Para pular MediaTypeSelector
  initialContentType, // Para pular MediaTypeSelector
  initialUrl, // Pre-fill link da imagem/viewer para impressos pendentes
  onMediaTypeConfirm // Callback para BackgroundScrapingModal
}) => {

  const hasInitializedRef = React.useRef(false);
  const [editedArticle, setEditedArticle] = useState(null);
  const [addTagsDialogOpen, setAddTagsDialogOpen] = useState(false);
  const [showMediaTypeSelector, setShowMediaTypeSelector] = useState(false);
  const [mainModalOpen, setMainModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rescraping, setRescraping] = useState(false);
  const [rescrapeMessage, setRescrapeMessage] = useState(null);

  // Estados para upload (apenas no modo create)
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Estado para OCR (extração de texto de imagens)
  const [ocrLoading, setOcrLoading] = useState(false);
  const [ocrRawText, setOcrRawText] = useState(null); // Texto bruto para extração de artigo específico
  const [ocrArticles, setOcrArticles] = useState([]); // Lista de matérias identificadas
  const [showArticleSelector, setShowArticleSelector] = useState(false); // Dialog de seleção
  const [showCropDialog, setShowCropDialog] = useState(false); // Dialog de seleção de área

  // Estado para seleção de thumbnail manual (mídia impressa)
  const [showThumbnailCropDialog, setShowThumbnailCropDialog] = useState(false);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);

  // Estado para upload via URL (mídia impressa)
  const [imageUrlInput, setImageUrlInput] = useState(initialUrl || '');
  const [urlLoading, setUrlLoading] = useState(false);

  // Estado para extração inteligente (Smart Scraper)
  const [isSmartScraping, setIsSmartScraping] = useState(false);

  // Estado para adicionar página via URL
  const [pageUrlInput, setPageUrlInput] = useState('');
  const [pageUrlLoading, setPageUrlLoading] = useState(false);

  // Estado para preservar blocos de imagem durante edição
  const [originalImageBlocks, setOriginalImageBlocks] = useState([]);

  // Estados para múltiplas páginas (mídia impressa - Jornal/Revista)
  const [pages, setPages] = useState([]); // Array de páginas: { pageNumber, file, preview, thumbnail, cropArea, ocrText }
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Página atual selecionada

  const { fontSize } = useViewSettings();
  const { fetchTags: refreshGlobalTags } = useTagSettings();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Calcular fontSize 20% menor para as tags
  let customFontSize = undefined;
  if (fontSize) {
    const match = fontSize.match(/([\d.]+)(rem|px|em)?/);
    if (match) {
      const value = parseFloat(match[1]);
      const unit = match[2] || 'rem';
      // Diminuir 20% do tamanho base
      customFontSize = (value * 0.8) + unit;
    }
  }

  // Verificar se é mídia impressa (Jornal/Revista)
  const isPrintMedia = editedArticle?.mediaType === 'Jornal' || editedArticle?.mediaType === 'Revista';
  const currentPrintPage = pages.length > 0 ? pages[currentPageIndex] : null;
  const activePrintImage = currentPrintPage?.preview || currentPrintPage?.storedUrl || currentPrintPage?.cloudinaryUrl || filePreview || editedArticle?.image;
  const printPageImages = pages.length > 0
    ? pages.map(page => page.preview || page.storedUrl || page.cloudinaryUrl).filter(Boolean)
    : [filePreview || editedArticle?.image].filter(Boolean);
  const currentPageMarkers = pages.length > 0
    ? (currentPrintPage?.markers || [])
    : (editedArticle?.markers || []);

  /**
   * Adiciona uma nova página ao array de páginas (mídia impressa)
   */
  const handleAddPage = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    let preview = null;

    if (file.type.startsWith('image/')) {
      // Criar preview para imagem
      preview = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
    } else if (file.type === 'application/pdf') {
      // Renderizar PDF como imagem
      preview = await renderPdfToImage(file);
    }

    if (!preview) return;

    const newPage = {
      pageNumber: pages.length + 1,
      file: file,
      preview: preview,
      thumbnail: null,
      cropArea: null,
      ocrText: null
    };

    setPages(prev => [...prev, newPage]);
    setCurrentPageIndex(pages.length); // Ir para a nova página

    // Se é a primeira página, também setar como arquivo principal (compatibilidade)
    if (pages.length === 0) {
      setSelectedFile(file);
      setFilePreview(preview);
      setFileType(file.type.startsWith('image/') ? 'image' : 'pdf');
    }
  };

  /**
   * Remove uma página do array
   */
  const handleRemovePage = (index) => {
    setPages(prev => {
      const newPages = prev.filter((_, i) => i !== index);
      // Renumerar páginas
      return newPages.map((page, i) => ({ ...page, pageNumber: i + 1 }));
    });

    // Ajustar índice atual se necessário
    if (currentPageIndex >= pages.length - 1) {
      setCurrentPageIndex(Math.max(0, pages.length - 2));
    }

    // Se removeu todas as páginas, limpar arquivo principal
    if (pages.length === 1) {
      setSelectedFile(null);
      setFilePreview(null);
      setFileType(null);
    }
  };

  /**
   * Navega para a página anterior
   */
  const handlePrevPage = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(prev => prev - 1);
    }
  };

  /**
   * Navega para a próxima página
   */
  const handleNextPage = () => {
    if (currentPageIndex < pages.length - 1) {
      setCurrentPageIndex(prev => prev + 1);
    }
  };

  /**
   * Atualiza dados de uma página específica (cropArea, thumbnail, ocrText)
   */
  const updatePageData = (index, data) => {
    setPages(prev => prev.map((page, i) =>
      i === index ? { ...page, ...data } : page
    ));
  };

  /**
   * Converte content de Array JSON para texto plano (para exibição no editor)
   */
  const getStoredPageUrl = (page) => page?.storedUrl || page?.cloudinaryUrl || page?.image || page?.url || page?.preview || null;

  const buildPrintPagesPayload = (fallbackImage = null, fallbackThumbnail = null) => {
    return pages
      .map((page, index) => ({
        pageNumber: index + 1,
        image: getStoredPageUrl(page) || (index === 0 ? fallbackImage : null),
        thumbnail: page.thumbnail || (index === 0 ? fallbackThumbnail : null),
        cropArea: page.cropArea || null,
        markers: page.markers || [],
        ocrText: page.ocrText || null
      }))
      .filter(page => !!page.image);
  };

  const contentToPlainText = (content) => {
    if (!content) return '';

    // Helper para remover HTML de uma string
    const stripHtmlTags = (html) => {
      if (!html || typeof html !== 'string') return html;

      // Se não tem tags HTML, retornar como está
      if (!html.includes('<')) return html;

      // Remover tags HTML preservando quebras de linha
      return html
        .replace(/<\/p>/gi, '\n\n')
        .replace(/<\/h[1-6]>/gi, '\n\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .trim();
    };

    // Se é Array de blocos JSON, extrair só o texto e remover HTML
    if (Array.isArray(content)) {
      return content
        .filter(block => block.type === 'text')
        .map(block => stripHtmlTags(block.content))
        .join('\n\n');
    }

    // Se é HTML string, extrair texto puro
    if (typeof content === 'string' && content.includes('<')) {
      return stripHtmlTags(content);
    }

    // Texto puro, retornar como está
    return content;
  };

  /**
   * Helper para formatar data de forma segura para o input type="date"
   * Evita crash (Invalid time value) se a data for inválida
   */
  const safeDateToIso = (dateValue) => {
    if (!dateValue) return '';
    try {
      const date = new Date(dateValue);
      // Validar se é uma data válida
      if (isNaN(date.getTime())) return '';
      return date.toISOString().split('T')[0];
    } catch (e) {
      console.warn('Data inválida encontrada:', dateValue);
      return '';
    }
  };

  /**
   * Converte texto plano de volta para Array JSON (para salvar)
   * Preserva blocos de imagem originais, intercalando com texto
   */
  const plainTextToContent = (text, imageBlocks = []) => {
    if (!text || typeof text !== 'string') {
      // Se não há texto, retornar apenas imagens (se houver)
      return imageBlocks.length > 0 ? imageBlocks : [];
    }

    // Criar blocos de texto
    const textBlocks = text
      .split('\n\n')
      .filter(p => p.trim())
      .map(p => ({
        type: 'text',
        content: p.trim()
      }));

    // Se não há imagens, retornar apenas texto
    if (imageBlocks.length === 0) {
      return textBlocks;
    }

    // Mesclar texto e imagens - imagens no final após o texto
    // Isso preserva a estrutura aproximada: texto primeiro, depois imagens
    return [...textBlocks, ...imageBlocks];
  };

  // Controla quando mostrar os diálogos
  useEffect(() => {
    if (!open) {
      // Modal fechado - resetar tudo
      setShowMediaTypeSelector(false);
      setMainModalOpen(false);
      setEditedArticle(null);
      setOriginalImageBlocks([]);
      setImageUrlInput('');
      setPages([]);
      setCurrentPageIndex(0);
      hasInitializedRef.current = false;
      return;
    }

    // Evitar re-inicialização ou carregamentos duplicados se já foi inicializado para este modal aberto
    if (hasInitializedRef.current) {
      return;
    }

    // Se tiver InitialUrl recebido dinamicamente ao abrir
    if (initialUrl) {
      setImageUrlInput(initialUrl);
    }

    if (mode === 'create') {
      // Só inicializar se ainda não temos um editedArticle (evitar sobrescrever)
      if (!editedArticle) {
        setEditedArticle({
          title: '',
          content: '',
          description: '',
          siteName: '',
          siteUrl: '',
          author: '',
          date: new Date().toISOString(), // ISO completo com Z para evitar ambiguidade UTC
          image: '',
          sentiment: 'neutral',
          mediaType: initialMediaType || 'Online',
          contentType: initialContentType || 'article',
          tags: []
        });
      }

      // Se temos tipos iniciais, pular MediaTypeSelector
      if (initialMediaType && initialContentType) {
        setShowMediaTypeSelector(false);
        setMainModalOpen(true);
      } else {
        setShowMediaTypeSelector(true);
        setMainModalOpen(false);
      }
      hasInitializedRef.current = true;
    } else if (article) {
      // Modo edição: verificar se o artigo tem content
      // Se não tem, buscar o artigo completo do backend
      const initializeEditMode = async (articleData) => {
        console.log('📝 [EDIT] Carregando artigo para edição:', {
          id: articleData._id,
          mediaType: articleData.mediaType,
          contentType: articleData.contentType,
          thumbnail: articleData.thumbnail
        });

        // Preservar blocos de imagem para restaurar ao salvar
        if (Array.isArray(articleData.content)) {
          const imageBlocks = articleData.content.filter(block => block.type === 'image');
          setOriginalImageBlocks(imageBlocks);
        } else {
          setOriginalImageBlocks([]);
        }

        const articleIsPrintMedia = ['Jornal', 'Revista'].includes(articleData.mediaType);
        if (articleIsPrintMedia) {
          const storedPages = (Array.isArray(articleData.pages) ? articleData.pages : [])
            .map((page, index) => ({
              ...page,
              pageNumber: page.pageNumber || index + 1,
              preview: getStoredPageUrl(page),
              storedUrl: getStoredPageUrl(page),
              file: null,
              fromUrl: true,
              markers: Array.isArray(page.markers) ? page.markers : [],
              cropArea: page.cropArea || null,
              ocrText: page.ocrText || null
            }))
            .filter(page => !!page.preview);

          // Artigos antigos podem ter somente a imagem principal, sem `pages`.
          if (storedPages.length === 0 && articleData.image) {
            storedPages.push({
              pageNumber: 1,
              preview: articleData.image,
              storedUrl: articleData.image,
              file: null,
              fromUrl: true,
              thumbnail: articleData.thumbnail || null,
              markers: Array.isArray(articleData.markers) ? articleData.markers : [],
              cropArea: articleData.cropArea || null,
              ocrText: null
            });
          }

          setPages(storedPages);
          setCurrentPageIndex(0);
        } else {
          setPages([]);
          setCurrentPageIndex(0);
        }

        setEditedArticle({
          ...articleData,
          date: articleData.date || articleData.publishedAt || (articleData.createdAt ? new Date(articleData.createdAt).toISOString() : new Date().toISOString()),
          content: contentToPlainText(articleData.content)
        });
        setMainModalOpen(true);
        setShowMediaTypeSelector(false);
        hasInitializedRef.current = true;
      };

      // Se o artigo não tem content (veio da listagem), buscar completo
      if (article.content === undefined) {
        setLoading(true);
        api.get(`/articles/${article._id}`)
          .then(res => {
            const fullArticle = res.data.data || res.data;
            initializeEditMode(fullArticle);
          })
          .catch(err => {
            console.error('Erro ao buscar artigo completo:', err);
            setError('Erro ao carregar artigo para edição');
            // Fallback: usar o artigo incompleto
            initializeEditMode(article);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // Artigo já tem content, usar diretamente
        initializeEditMode(article);
      }
    } else {
      // Modo edição sem artigo (pode ser upload) - inicializar com valores padrão
      setEditedArticle({
        title: '',
        content: '',
        description: '',
        siteName: '',
        siteUrl: '',
        author: '',
        date: new Date().toISOString(), // ISO completo com Z para evitar ambiguidade UTC
        image: '',
        sentiment: 'neutral',
        mediaType: 'Online',
        contentType: 'article',
        tags: []
      });
      setMainModalOpen(true);
      setShowMediaTypeSelector(false);
      hasInitializedRef.current = true;
    }
  }, [article, mode, open]);

  // Handler quando usuário confirma seleção de mídia (só usado no modo create)
  const handleMediaTypeConfirm = (selectedTypes) => {
    console.log('🎯 handleMediaTypeConfirm chamado com:', selectedTypes);

    if (mode === 'create') {
      // Se temos callback do BackgroundScrapingModal, usar ele
      if (onMediaTypeConfirm) {
        onMediaTypeConfirm(selectedTypes);
        return;
      }

      // Modo criação: inicializar artigo com tipos selecionados
      const newArticle = {
        title: '',
        content: '',
        description: '',
        siteName: '',
        siteUrl: '',
        author: '',
        date: new Date().toISOString(), // ISO completo com Z para evitar ambiguidade UTC
        image: '',
        sentiment: 'neutral',
        mediaType: selectedTypes.mediaType,
        contentType: selectedTypes.contentType,
        tags: []
      };

      setEditedArticle(newArticle);
      setShowMediaTypeSelector(false);
      setMainModalOpen(true);
    }
  };


  // Handler para fechar o seletor de mídia
  const handleMediaTypeCancel = () => {
    setShowMediaTypeSelector(false);
    onClose(); // Fecha tudo
  };

  const handleChange = (field) => (event) => {
    let value = event.target.value;
    // Para o campo date (input type="date"), o valor é "YYYY-MM-DD" sem timezone.
    // Ao salvar sem timezone, o backend pode interpretar como horário local (UTC-3),
    // causando o problema de "um dia a menos" na página pública.
    // Solução: converter para ISO string com T12:00:00.000Z (meio-dia UTC)
    // Isso garante que em qualquer timezone do mundo a data exibida seja a mesma.
    if (field === 'date' && value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      value = `${value}T12:00:00.000Z`;
    }
    setEditedArticle(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Mapeamento dinâmico: contentType baseado em mediaType
  const getContentTypeOptions = (mediaType) => {
    const options = {
      // Mídias Digitais
      YouTube: [
        { value: 'video', label: 'Vídeo' },
        { value: 'short', label: 'Short' }
      ],
      Twitter: [
        { value: 'tweet', label: 'Tweet' },
        { value: 'video', label: 'Vídeo' }
      ],
      Instagram: [
        { value: 'post', label: 'Post' },
        { value: 'reel', label: 'Reel' },
        { value: 'story', label: 'Stories' },
        { value: 'video', label: 'Vídeo' }
      ],
      TikTok: [
        { value: 'video', label: 'Vídeo' }
      ],
      Facebook: [
        { value: 'post', label: 'Post' },
        { value: 'reel', label: 'Reel' },
        { value: 'photo', label: 'Foto' },
        { value: 'story', label: 'Stories' },
        { value: 'video', label: 'Vídeo' }
      ],
      LinkedIn: [
        { value: 'post', label: 'Post' },
        { value: 'video', label: 'Vídeo' },
        { value: 'article', label: 'Artigo' }
      ],
      Threads: [
        { value: 'post', label: 'Post' },
        { value: 'video', label: 'Vídeo' }
      ],
      Pinterest: [
        { value: 'pin', label: 'Pin' },
        { value: 'video', label: 'Vídeo' }
      ],
      Online: [
        { value: 'article', label: 'Artigo' },
        { value: 'video', label: 'Vídeo' }
      ],
      // Mídias Impressas
      Jornal: [
        { value: 'article', label: 'Matéria' }
      ],
      Revista: [
        { value: 'article', label: 'Matéria' }
      ],
      // Mídias Eletrônicas
      TV: [
        { value: 'video', label: 'Matéria/Reportagem' }
      ],
      Radio: [
        { value: 'article', label: 'Menção/Inserção' }
      ],
      Podcast: [
        { value: 'article', label: 'Episódio' }
      ]
    };
    return options[mediaType] || options.Online;
  };

  // Handler especial para mediaType que reseta contentType
  const handleMediaTypeChange = (event) => {
    const newMediaType = event.target.value;
    const availableOptions = getContentTypeOptions(newMediaType);
    const defaultContentType = availableOptions[0]?.value || 'article';

    setEditedArticle(prev => ({
      ...prev,
      mediaType: newMediaType,
      contentType: defaultContentType // Reseta para primeira opção válida
    }));
  };

  const handleAddTags = async (newTags) => {
    try {
      // Separar tags novas (sem _id) das existentes
      const tagsToCreate = newTags.filter(tag => !tag._id);
      const existingTags = newTags.filter(tag => tag._id);
      let createdTags = [];

      // Criar tags novas no backend
      if (tagsToCreate.length > 0) {
        const createPromises = tagsToCreate.map(tag =>
          api.post('/tags', { name: tag.name })
        );
        const createdResponses = await Promise.all(createPromises);
        createdTags = createdResponses.map(res => res.data.data);
      }

      // Juntar todas as tags com _id
      const allTags = [...existingTags, ...createdTags];
      await onAddTags(article._id, allTags);

      // Atualizar lista global de tags se novas tags foram criadas
      if (createdTags.length > 0) {
        // Aguardar 1 segundo para garantir persistência no banco
        await new Promise(resolve => setTimeout(resolve, 1000));
        await refreshGlobalTags();
      }

      // Buscar o artigo atualizado e atualizar o estado local
      const updatedArticleRes = await api.get(`/articles/${article._id}`);
      setEditedArticle(updatedArticleRes.data.data);
      setAddTagsDialogOpen(false);
    } catch (err) {
      console.error('Erro ao adicionar tags:', err);
      setError(err.message);
    }
  };

  const handleRemoveTag = async (tagId) => {
    try {
      await onRemoveTag(article._id, tagId);
      // Buscar o artigo atualizado e atualizar o estado local
      const updatedArticleRes = await api.get(`/articles/${article._id}`);
      setEditedArticle(updatedArticleRes.data.data);
    } catch (err) {
      setError(err.message);
    }
  };

  /**
   * Renderiza a primeira página de um PDF como imagem (DataURL)
   * @param {File} file - Arquivo PDF
   * @returns {Promise<string>} - DataURL da imagem
   */
  const renderPdfToImage = async (file) => {
    try {
      console.log('📄 Renderizando PDF como imagem...');

      // Ler arquivo como ArrayBuffer
      const arrayBuffer = await file.arrayBuffer();

      // Carregar PDF
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      console.log('📄 PDF carregado, páginas:', pdf.numPages);

      // Pegar primeira página
      const page = await pdf.getPage(1);

      // Escala para boa qualidade (2x)
      const scale = 2;
      const viewport = page.getViewport({ scale });

      // Criar canvas
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      // Renderizar página no canvas
      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise;

      // Converter para DataURL (JPEG para menor tamanho)
      const dataUrl = canvas.toDataURL('image/jpeg', 0.92);
      console.log('✅ PDF renderizado como imagem');

      return dataUrl;
    } catch (error) {
      console.error('❌ Erro ao renderizar PDF:', error);
      return null;
    }
  };

  const setPrimaryPrintPage = (file, preview) => {
    if (!['Jornal', 'Revista'].includes(editedArticle?.mediaType) || !preview) return;

    setPages(prev => {
      const firstPage = {
        pageNumber: 1,
        file,
        preview,
        thumbnail: null,
        cropArea: prev[0]?.cropArea || null,
        markers: prev[0]?.markers || [],
        ocrText: prev[0]?.ocrText || null
      };
      const additionalPages = prev.slice(1).map((page, index) => ({
        ...page,
        pageNumber: index + 2
      }));
      return [firstPage, ...additionalPages];
    });
    setCurrentPageIndex(0);
  };
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    console.log('📁 Arquivo selecionado:', {
      name: file.name,
      size: file.size,
      type: file.type,
      mode
    });

    let type = null;
    if (file.type.startsWith('image/')) {
      type = 'image';
      console.log('🖼️ Arquivo identificado como imagem');
    } else if (file.type.startsWith('video/')) {
      type = 'video';
      console.log('🎬 Arquivo identificado como vídeo');
    } else if (file.type.startsWith('audio/')) {
      type = 'audio';
      console.log('🎵 Arquivo identificado como áudio');
    } else if (file.type === 'application/pdf') {
      type = 'pdf';
      console.log('📄 Arquivo identificado como PDF');
    } else {
      // Arquivo sem tipo identificado - assumir vídeo e tentar gerar thumbnail
      type = 'video';
      console.log('🎬 Arquivo sem tipo identificado, assumindo vídeo:', file.type);
    }

    // No modo edição, não mostrar seletor - deixar backend detectar automaticamente
    if (mode === 'edit') {
      console.log('🎬 Modo edição: arquivo pronto para upload direto (detecção automática)');
      setSelectedFile(file);
      setFileType(type);

      // Criar preview se for imagem, vídeo ou PDF
      if (type === 'image') {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result);
          setPrimaryPrintPage(file, reader.result);
        };
        reader.readAsDataURL(file);
      } else if (type === 'video') {
        const videoUrl = URL.createObjectURL(file);
        setFilePreview(videoUrl);
      } else if (type === 'pdf') {
        // Renderizar PDF como imagem para preview e seleção
        renderPdfToImage(file).then(dataUrl => {
          if (dataUrl) {
            setFilePreview(dataUrl);
            setPrimaryPrintPage(file, dataUrl);
          }
        });
      } else {
        setFilePreview(null);
      }

      return;
    }

    // No modo criação, prosseguir normalmente
    console.log('➕ Modo criação: arquivo pronto para upload');
    setSelectedFile(file);
    setFileType(type);

    if (type === 'image') {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFilePreview(reader.result);
        setPrimaryPrintPage(file, reader.result);
      };
      reader.readAsDataURL(file);
    } else if (type === 'video') {
      const videoUrl = URL.createObjectURL(file);
      setFilePreview(videoUrl);
      console.log('🎬 Vídeo selecionado:', file.name, 'Tipo:', file.type);
    } else if (type === 'pdf') {
      // Renderizar PDF como imagem para preview e seleção
      renderPdfToImage(file).then(dataUrl => {
        if (dataUrl) {
          setFilePreview(dataUrl);
          setPrimaryPrintPage(file, dataUrl);
        }
      });
    } else {
      setFilePreview(null);
    }
  };


  const handleRemoveFile = () => {
    setSelectedFile(null);
    setFilePreview(null);
    setFileType(null);
    setPages([]);
    setCurrentPageIndex(0);
    const fileInput = document.getElementById('article-media-file-input');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleClearImage = () => {
    setEditedArticle(prev => ({
      ...prev,
      image: '',
      thumbnail: '',
      allImages: [],
      carouselMedia: []
    }));
    setOriginalImageBlocks([]);
    handleRemoveFile();
  };

  /**
   * Remove uma imagem específica da galeria allImages
   */
  const handleRemoveAllImage = (index) => {
    setEditedArticle(prev => ({
      ...prev,
      allImages: (prev.allImages || []).filter((_, i) => i !== index)
    }));
  };

  /**
   * Remove um item específico da galeria carouselMedia
   */
  const handleRemoveCarouselMedia = (index) => {
    setEditedArticle(prev => ({
      ...prev,
      carouselMedia: (prev.carouselMedia || []).filter((_, i) => i !== index)
    }));
  };

  /**
   * Remove uma imagem que faz parte do conteúdo estruturado
   */
  const handleRemoveContentImage = (index) => {
    setOriginalImageBlocks(prev => prev.filter((_, i) => i !== index));
  };

  /**
   * Carrega imagem a partir de uma URL externa (para mídia impressa)
   * Faz download da imagem, upload para Cloudinary e configura como preview
   */
  const handleLoadFromUrl = async () => {
    if (!imageUrlInput || !imageUrlInput.trim()) {
      setError('Digite uma URL de imagem válida');
      return;
    }

    try {
      setUrlLoading(true);
      setError(null);

      console.log('📥 Carregando imagem de URL:', imageUrlInput);

      const response = await api.post('/articles/upload-from-url', {
        imageUrl: imageUrlInput.trim()
      }, { timeout: 120000 });

      if (response.data.success) {
        const { cloudinaryUrl, storedUrl: uploadedUrl, mediaUrl, thumbnailUrl, width, height } = response.data.data;
        const storedUrl = uploadedUrl || mediaUrl || cloudinaryUrl;

        console.log('✅ Imagem carregada com sucesso:', { cloudinaryUrl, width, height });

        // Configurar como se fosse um arquivo selecionado
        setFilePreview(storedUrl);
        setFileType('image');
        // Criar um objeto fake de arquivo para o fluxo funcionar
        setSelectedFile({
          name: 'imagem-importada.jpg',
          type: 'image/jpeg',
          size: 0,
          fromUrl: true, // Marcador para saber que veio de URL
          cloudinaryUrl: storedUrl,
          storedUrl: storedUrl // URL já no Cloudinary
        });

        if (isPrintMedia) {
          setPages(prev => {
            const firstPage = {
              pageNumber: 1,
              file: null,
              preview: storedUrl,
              thumbnail: thumbnailUrl || null,
              cropArea: prev[0]?.cropArea || null,
              markers: prev[0]?.markers || [],
              ocrText: prev[0]?.ocrText || null,
              fromUrl: true,
              cloudinaryUrl: storedUrl,
              storedUrl: storedUrl
            };
            const additionalPages = prev.slice(1).map((page, index) => ({
              ...page,
              pageNumber: index + 2
            }));
            return [firstPage, ...additionalPages];
          });
          setCurrentPageIndex(0);
        }

        // Limpar input da URL
        setImageUrlInput('');

        // Configurar thumbnail se disponível
        if (thumbnailUrl) {
          setThumbnailPreview(thumbnailUrl);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar imagem de URL:', error);
      setError(error.response?.data?.error || error.message || 'Erro ao carregar imagem da URL');
    } finally {
      setUrlLoading(false);
    }
  };

  /**
   * Adiciona páginas ao array via URL (mídia impressa)
   * Suporta múltiplas URLs separadas por linha, vírgula ou espaço
   */
  const handleAddPageFromUrl = async () => {
    if (!pageUrlInput || !pageUrlInput.trim()) {
      setError('Digite uma ou mais URLs de imagem');
      return;
    }

    // Extrair múltiplas URLs (separadas por linha, vírgula ou espaço)
    const urls = pageUrlInput
      .split(/[\n,\s]+/)
      .map(url => url.trim())
      .filter(url => url.length > 0 && (url.startsWith('http://') || url.startsWith('https://')));

    if (urls.length === 0) {
      setError('Nenhuma URL válida encontrada. URLs devem começar com http:// ou https://');
      return;
    }

    try {
      setPageUrlLoading(true);
      setError(null);

      console.log(`📥 Carregando ${urls.length} página(s) de URL...`);

      let successCount = 0;
      let errorCount = 0;
      let currentPages = [...pages];

      for (let i = 0; i < urls.length; i++) {
        const url = urls[i];
        try {
          console.log(`📥 [${i + 1}/${urls.length}] Carregando:`, url);

          const response = await api.post('/articles/upload-from-url', {
            imageUrl: url
          }, { timeout: 120000 });

          if (response.data.success) {
            const { cloudinaryUrl, storedUrl: uploadedUrl, mediaUrl, thumbnailUrl } = response.data.data;
            const storedUrl = uploadedUrl || mediaUrl || cloudinaryUrl;

            const newPage = {
              pageNumber: currentPages.length + 1,
              file: null,
              preview: storedUrl,
              thumbnail: thumbnailUrl || null,
              cropArea: null,
              ocrText: null,
              fromUrl: true,
              cloudinaryUrl: storedUrl,
              storedUrl: storedUrl
            };

            // Se é a primeira página, também setar como arquivo principal
            if (currentPages.length === 0) {
              setFilePreview(storedUrl);
              setFileType('image');
              setSelectedFile({
                name: 'pagina-importada.jpg',
                type: 'image/jpeg',
                size: 0,
                fromUrl: true,
                cloudinaryUrl: storedUrl,
                storedUrl: storedUrl
              });
              if (thumbnailUrl) {
                setThumbnailPreview(thumbnailUrl);
              }
            }

            currentPages.push(newPage);
            successCount++;
            console.log(`✅ [${i + 1}/${urls.length}] P??gina carregada:`, storedUrl);
          }
        } catch (err) {
          errorCount++;
          console.error(`❌ [${i + 1}/${urls.length}] Erro ao carregar:`, url, err.message);
        }
      }

      // Atualizar estado com todas as páginas
      setPages(currentPages);
      setCurrentPageIndex(currentPages.length - 1); // Ir para a última página

      // Limpar input
      setPageUrlInput('');

      // Mostrar resultado
      if (errorCount > 0) {
        setError(`${successCount} página(s) carregada(s), ${errorCount} erro(s)`);
      } else {
        console.log(`✅ Todas as ${successCount} páginas carregadas com sucesso!`);
      }
    } catch (error) {
      console.error('Erro ao carregar páginas de URL:', error);
      setError(error.response?.data?.error || error.message || 'Erro ao carregar páginas');
    } finally {
      setPageUrlLoading(false);
    }
  };

  /**
   * Abre o dialog de seleção de área da imagem antes do OCR
   * Disponível apenas para Jornal e Revista quando uma imagem ou PDF é selecionado
   */
  const handleOcrExtract = () => {
    const canUseSelectedFile = selectedFile && filePreview && (fileType === 'image' || fileType === 'pdf');
    const canUseExistingImage = !selectedFile && !!editedArticle?.image;

    if (!activePrintImage || (!canUseSelectedFile && !canUseExistingImage)) {
      setError('Selecione uma imagem ou PDF para extrair o texto');
      return;
    }
    // Abrir dialog de seleção de área (para PDF, usa o preview renderizado)
    setShowCropDialog(true);
  };

  /**
   * Extrai OCR usando todas as páginas completas inseridas.
   * Este fluxo é para publicações multipágina em que o artigo ocupa tudo que foi anexado.
   */
  const handleAllPagesOcrExtract = async () => {
    if (!printPageImages.length) {
      setError('Adicione ao menos uma página para extrair o texto');
      return;
    }

    const documentType = editedArticle?.mediaType === 'Revista' ? 'revista' : 'jornal';

    try {
      setOcrLoading(true);
      setError(null);

      console.log(`Iniciando OCR para todas as ${printPageImages.length} paginas (${documentType})...`);

      const extractResponse = await api.post('/ocr/extract-multiple', {
        images: printPageImages,
        documentType,
        language: 'pt-BR'
      }, { timeout: 180000 });

      if (!extractResponse.data.success) {
        throw new Error(extractResponse.data.error || 'Não foi possível extrair o texto das páginas');
      }

      const { combinedText, text, rawText, summary, extractedFields, pages: ocrPages } = extractResponse.data;
      const finalText = text || combinedText || rawText || '';
      const firstSuccessfulPage = Array.isArray(ocrPages)
        ? ocrPages.find(page => page.success && page.extractedFields)
        : null;
      const fields = extractedFields || firstSuccessfulPage?.extractedFields || {};

      setOcrRawText(rawText || combinedText || finalText);

      setEditedArticle(prev => ({
        ...prev,
        content: finalText,
        title: prev.title || fields?.title || '',
        description: prev.description || summary || fields?.subtitle || '',
        author: prev.author || fields?.author || '',
        date: fields?.publishedAt || prev.date || new Date().toISOString(),
        siteName: prev.siteName || fields?.source || ''
      }));

      if (Array.isArray(ocrPages) && ocrPages.length > 0) {
        setPages(prev => prev.map((page, index) => ({
          ...page,
          ocrText: ocrPages[index]?.text || ocrPages[index]?.rawText || page.ocrText || null
        })));
      }

      console.log('OCR de todas as paginas concluido com sucesso!');
    } catch (error) {
      console.error('Erro no OCR de todas as páginas:', error);
      setError(error.response?.data?.error || error.message || 'Erro ao extrair texto das páginas');
    } finally {
      setOcrLoading(false);
    }
  };
  /**
   * Processa marcações de imagem com OCR
   * Chamado após o usuário confirmar as marcações no ImageCropDialog
   *
   * NOVO SISTEMA DE MARCADORES:
   * - Mantém a página completa (não recorta mais)
   * - Salva marcadores (OCR e Destaques) como coordenadas
   * - Extrai texto apenas das áreas marcadas como OCR
   *
   * @param {object} result - Resultado do ImageCropDialog
   *   - markers: Array de todos os marcadores (OCR e destaques)
   *   - ocrAreas: Array de marcadores OCR (para extração de texto)
   *   - keepFullImage: true (sempre mantém imagem completa)
   */
  const handleCropComplete = async (result, legacyCropCoordinates) => {
    // Determinar tipo de documento baseado no mediaType
    const documentType = editedArticle?.mediaType === 'Revista' ? 'revista' : 'jornal';

    // Novo formato: objeto com markers e ocrAreas
    const isNewFormat = result && typeof result === 'object' && 'markers' in result;

    // DEBUG: Log detalhado
    console.log('📐 [DEBUG] handleCropComplete chamado:', {
      isNewFormat,
      markers: isNewFormat ? result.markers?.length : 0,
      ocrAreas: isNewFormat ? result.ocrAreas?.length : 0,
      keepFullImage: isNewFormat ? result.keepFullImage : false
    });

    if (isNewFormat) {
      // NOVO SISTEMA: Salvar marcadores no artigo
      const { markers, ocrAreas } = result;
      const pageMarkerData = {
        markers: markers || [],
        cropArea: ocrAreas && ocrAreas.length > 0 ? ocrAreas[0].coordinates : null
      };

      setEditedArticle(prev => ({
        ...prev,
        markers: pages.length === 0 || currentPageIndex === 0 ? pageMarkerData.markers : (prev.markers || []),
        // Manter cropArea para compatibilidade (primeiro marcador OCR)
        cropArea: pages.length === 0 || currentPageIndex === 0 ? pageMarkerData.cropArea : prev.cropArea
      }));

      if (pages.length > 0) {
        updatePageData(currentPageIndex, pageMarkerData);
      }

      // Se não há áreas OCR, apenas salvar os marcadores (destaques)
      if (!ocrAreas || ocrAreas.length === 0) {
        console.log('ℹ️ Apenas marcadores de destaque, sem OCR');
        return;
      }

      try {
        setOcrLoading(true);
        setError(null);

        let extractResponse;

        // Gerar imagens recortadas das áreas OCR usando canvas
        const croppedImages = await generateCroppedImagesFromMarkers(activePrintImage, ocrAreas);

        if (ocrAreas.length === 1) {
          // Uma única área OCR
          console.log(`📄 Iniciando OCR para ${documentType} (1 área marcada)...`);

          extractResponse = await api.post('/ocr/extract', {
            fullImage: activePrintImage,
            croppedImage: croppedImages[0],
            documentType,
            language: 'pt-BR'
          }, { timeout: 120000 });
        } else {
          // Múltiplas áreas OCR
          console.log(`📄 Iniciando OCR para ${ocrAreas.length} áreas marcadas (${documentType})...`);

          extractResponse = await api.post('/ocr/extract-multiple', {
            fullImage: activePrintImage,
            croppedImages: croppedImages,
            documentType,
            language: 'pt-BR'
          }, { timeout: 120000 });
        }

        if (!extractResponse.data.success) {
          throw new Error(extractResponse.data.error || 'Não foi possível extrair o texto da imagem');
        }

        const { text, rawText, summary, extractedFields } = extractResponse.data;

        setOcrRawText(rawText || text);

        setEditedArticle(prev => ({
          ...prev,
          content: text,
          title: prev.title || extractedFields?.title || '',
          description: prev.description || summary || extractedFields?.subtitle || '',
          author: prev.author || extractedFields?.author || '',
          date: extractedFields?.publishedAt || prev.date || new Date().toISOString(),
          siteName: prev.siteName || extractedFields?.source || ''
        }));

        console.log('✅ Texto extraído com sucesso!');

      } catch (error) {
        console.error('Erro no OCR:', error);
        setError(error.response?.data?.error || error.message || 'Erro ao extrair texto da imagem');
      } finally {
        setOcrLoading(false);
      }
    } else {
      // FORMATO LEGADO: compatibilidade com código antigo
      const croppedImage = result;
      const cropCoordinates = legacyCropCoordinates;

      const isMultipleSelections = cropCoordinates?.multiple === true;

      if (cropCoordinates && !isMultipleSelections) {
        setEditedArticle(prev => ({
          ...prev,
          cropArea: cropCoordinates
        }));
      } else if (isMultipleSelections) {
        const allCoordinates = croppedImage.map(item => item.coordinates);
        setEditedArticle(prev => ({
          ...prev,
          cropArea: allCoordinates
        }));
      }

      try {
        setOcrLoading(true);
        setError(null);

        let extractResponse;

        if (isMultipleSelections && Array.isArray(croppedImage)) {
          const croppedImages = croppedImage.map(item => item.image);

          extractResponse = await api.post('/ocr/extract-multiple', {
            fullImage: activePrintImage,
            croppedImages: croppedImages,
            documentType,
            language: 'pt-BR'
          }, { timeout: 120000 });
        } else {
          const isImageCropped = croppedImage !== filePreview;

          if (isImageCropped) {
            extractResponse = await api.post('/ocr/extract', {
              fullImage: activePrintImage,
              croppedImage: croppedImage,
              documentType,
              language: 'pt-BR'
            }, { timeout: 120000 });
          } else {
            extractResponse = await api.post('/ocr/extract', {
              image: croppedImage,
              documentType,
              language: 'pt-BR'
            }, { timeout: 120000 });
          }
        }

        if (!extractResponse.data.success) {
          throw new Error(extractResponse.data.error || 'Não foi possível extrair o texto da imagem');
        }

        const { text, rawText, summary, extractedFields } = extractResponse.data;

        setOcrRawText(rawText || text);

        setEditedArticle(prev => ({
          ...prev,
          content: text,
          title: prev.title || extractedFields?.title || '',
          description: prev.description || summary || extractedFields?.subtitle || '',
          author: prev.author || extractedFields?.author || '',
          date: extractedFields?.publishedAt || prev.date || new Date().toISOString(),
          siteName: prev.siteName || extractedFields?.source || ''
        }));

        console.log('✅ Texto extraído com sucesso!');

      } catch (error) {
        console.error('Erro no OCR:', error);
        setError(error.response?.data?.error || error.message || 'Erro ao extrair texto da imagem');
      } finally {
        setOcrLoading(false);
      }
    }
  };

  /**
   * Gera imagens recortadas a partir dos marcadores OCR
   * Usa canvas para recortar as áreas marcadas da imagem original
   */
  const generateCroppedImagesFromMarkers = async (imageSrc, ocrMarkers) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const croppedImages = ocrMarkers.map(marker => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const coords = marker.coordinates;
          const x = (coords.x / 100) * img.naturalWidth;
          const y = (coords.y / 100) * img.naturalHeight;
          const width = (coords.width / 100) * img.naturalWidth;
          const height = (coords.height / 100) * img.naturalHeight;

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, x, y, width, height, 0, 0, width, height);

          return canvas.toDataURL('image/jpeg', 0.95);
        });

        resolve(croppedImages);
      };
      if (!imageSrc || imageSrc.startsWith('data:') || imageSrc.startsWith('blob:')) {
        img.src = imageSrc;
      } else {
        const separator = imageSrc.includes('?') ? '&' : '?';
        img.src = `${imageSrc}${separator}_canvas=${Date.now()}`;
      }
    });
  };

  /**
   * Quando usuário seleciona uma matéria específica do dialog
   */
  const handleArticleSelect = async (articleInfo) => {
    const documentType = editedArticle?.mediaType === 'Revista' ? 'revista' : 'jornal';

    try {
      setOcrLoading(true);
      setShowArticleSelector(false);
      setError(null);

      console.log(`📰 Extraindo matéria: ${articleInfo.titulo}`);

      const response = await api.post('/ocr/extract-article', {
        rawText: ocrRawText,
        articleInfo,
        documentType
      }, { timeout: 120000 });

      if (response.data.success && response.data.text) {
        setEditedArticle(prev => ({
          ...prev,
          content: response.data.text,
          title: prev.title || response.data.title || articleInfo.titulo,
          description: prev.description || articleInfo.resumo || ''
        }));

        console.log('✅ Matéria extraída com sucesso!');
      } else {
        throw new Error(response.data.error || 'Não foi possível extrair a matéria');
      }

    } catch (error) {
      console.error('Erro ao extrair matéria:', error);
      setError(error.response?.data?.error || error.message || 'Erro ao extrair matéria específica');
    } finally {
      setOcrLoading(false);
      setOcrRawText(null);
      setOcrArticles([]);
    }
  };

  /**
   * Abre o dialog de seleção de área da thumbnail (mídia impressa)
   */
  const handleThumbnailSelect = () => {
    if (!filePreview && !editedArticle?.image) {
      setError('Selecione uma imagem primeiro para definir a thumbnail');
      return;
    }
    setShowThumbnailCropDialog(true);
  };

  /**
   * Processa a área selecionada como thumbnail
   * @param {string} croppedImage - Imagem recortada em base64
   */
  const handleThumbnailCropComplete = (croppedImage) => {
    // Guardar preview da thumbnail selecionada
    setThumbnailPreview(croppedImage);

    // Atualizar o editedArticle com a thumbnail base64
    // Será convertida para URL na hora de salvar
    setEditedArticle(prev => ({
      ...prev,
      thumbnail: croppedImage,
      thumbnailIsBase64: true // Flag para indicar que precisa de upload
    }));

    console.log('🖼️ Thumbnail selecionada manualmente');
    setShowThumbnailCropDialog(false);
  };

  /**
   * Cancela seleção de matéria e usa texto estruturado completo
   */
  const handleArticleSelectorClose = async () => {
    setShowArticleSelector(false);

    // Usar o texto estruturado completo como fallback
    if (ocrRawText) {
      try {
        setOcrLoading(true);
        const documentType = editedArticle?.mediaType === 'Revista' ? 'revista' : 'jornal';

        const response = await api.post('/ocr/structure', {
          rawText: ocrRawText,
          documentType
        });

        if (response.data.success && response.data.text) {
          setEditedArticle(prev => ({
            ...prev,
            content: response.data.text
          }));
        }
      } catch (error) {
        // Fallback: usar texto bruto
        setEditedArticle(prev => ({
          ...prev,
          content: ocrRawText
        }));
      } finally {
        setOcrLoading(false);
      }
    }

    setOcrRawText(null);
    setOcrArticles([]);
  };

  /**
   * Re-scrape do conteúdo do artigo a partir da URL original
   */
  const handleRescrape = async () => {
    if (!editedArticle?._id || editedArticle?.mediaType !== 'Online') {
      setRescrapeMessage({ type: 'error', text: 'Re-scrape só está disponível para artigos Online salvos' });
      return;
    }

    if (!editedArticle?.siteUrl) {
      setRescrapeMessage({ type: 'error', text: 'Artigo não possui URL de origem' });
      return;
    }

    try {
      setRescraping(true);
      setRescrapeMessage(null);

      const response = await api.post(`/articles/${editedArticle._id}/rescrape`);

      if (response.data.success) {
        // Atualizar o artigo editado com os novos dados
        setEditedArticle(response.data.data);
        setRescrapeMessage({
          type: 'success',
          text: `Conteúdo re-extraído com sucesso usando ${response.data.scraperUsed}`
        });

        // Notificar componente pai sobre a atualização
        if (onSave) {
          onSave(response.data.data);
        }
      } else {
        setRescrapeMessage({ type: 'error', text: response.data.message || 'Erro ao re-scrapear' });
      }
    } catch (err) {
      console.error('Erro no re-scrape:', err);
      setRescrapeMessage({
        type: 'error',
        text: err.response?.data?.message || 'Erro ao re-extrair conteúdo da URL'
      });
    } finally {
      setRescraping(false);
    }
  };

  /**
   * Extrai o conteúdo da URL via IA (Smart Scraper / MensureVision)
   */
  const handleSmartScrape = async () => {
    if (!editedArticle?.siteUrl) {
      setError('Cole a URL no campo "URL do Site" primeiro para extrair.');
      return;
    }

    try {
      setIsSmartScraping(true);
      setError(null);

      const response = await api.post('/articles/scrape-smart', {
        url: editedArticle.siteUrl
      }, { timeout: 120000 });

      if (response.data.success && response.data.data) {
        const extractedData = response.data.data;
        
        setEditedArticle(prev => ({
          ...prev,
          title: extractedData.title || prev.title,
          content: extractedData.content || prev.content,
          author: extractedData.author || prev.author,
          date: extractedData.date ? new Date(extractedData.date).toISOString() : prev.date
        }));
        
        console.log('✅ Conteúdo extraído com sucesso via IA');
      }
    } catch (err) {
      console.error('Erro na extração via IA:', err);
      setError(err.response?.data?.error || err.response?.data?.message || err.message || 'Erro ao extrair conteúdo usando IA');
    } finally {
      setIsSmartScraping(false);
    }
  };

  const handleSave = async () => {

    try {
      setLoading(true);
      setError(null);

      // Fallback: se imagem estiver vazia, usar thumbnail padrao da Mensure no R2
      const MENSURE_FALLBACK_IMAGE = 'https://media.mensuremidia.com.br/system/fallbacks/mensure-thumbnail.png';
      const articleToSave = {
        ...editedArticle,
        image: editedArticle.image?.trim() ? editedArticle.image : MENSURE_FALLBACK_IMAGE
      };

      if (!articleToSave.title?.trim()) {
        setError('O título é obrigatório');
        setLoading(false);
        return;
      }

      let response;

      console.log('🔍 Verificando upload:', {
        hasSelectedFile: !!selectedFile,
        fileName: selectedFile?.name,
        fileSize: selectedFile?.size,
        mode
      });

      // Se a imagem veio de URL (já está no Cloudinary), usar endpoint JSON em vez de FormData
      if (selectedFile && selectedFile.fromUrl && (selectedFile.storedUrl || selectedFile.cloudinaryUrl)) {
        console.log('📤 Imagem de URL - usando endpoint JSON (não FormData)');

        // Preparar dados do artigo com a URL armazenada
        const articleData = {
          ...articleToSave,
          image: selectedFile.storedUrl || selectedFile.cloudinaryUrl,
          thumbnail: thumbnailPreview || articleToSave.thumbnail,
          mediaType: articleToSave.mediaType || 'Jornal',
          contentType: articleToSave.contentType || 'article'
        };

        // Se tiver marcadores (OCR/Destaques), incluir
        if (articleToSave.markers) {
          articleData.markers = articleToSave.markers;
        }

        const articleIsPrintMedia = articleData.mediaType === 'Jornal' || articleData.mediaType === 'Revista';
        const printPagesPayload = articleIsPrintMedia && pages.length > 0
          ? buildPrintPagesPayload(selectedFile.storedUrl || selectedFile.cloudinaryUrl, articleData.thumbnail)
          : [];

        if (printPagesPayload.length > 0) {
          articleData.pages = printPagesPayload;
          articleData.image = printPagesPayload[0].image;
          articleData.thumbnail = printPagesPayload[0].thumbnail || articleData.thumbnail;
          console.log('Paginas impressas adicionadas ao payload JSON:', printPagesPayload.length);
        }

        console.log('📤 Dados do artigo (URL):', articleData);

        if (mode === 'create') {
          response = await api.post('/articles', articleData);
        } else {
          response = await api.put(`/articles/${articleToSave._id}`, articleData);
        }

        if (onSave) {
          onSave(response.data.data);
        }
        if (mode === 'create') {
          window.dispatchEvent(new CustomEvent('refresh-usage-counter'));
        }
        onClose();
      } else if (selectedFile) {
        // Upload de mídia (create ou edit) - arquivo real
        const formDataToSend = new FormData();

        // Preparar conteúdo para envio (Texto plano ou Array JSON se houver fotos preservadas)
        let finalContent = editedArticle.content;
        if (originalImageBlocks && originalImageBlocks.length > 0) {
          finalContent = JSON.stringify([
            { type: 'text', content: editedArticle.content },
            ...originalImageBlocks
          ]);
          console.log('📝 [DEBUG] Conteúdo estruturado (com fotos) reconstruído para FormData');
        }

        const allowedFields = ['title', 'link', 'description', 'siteName', 'siteUrl', 'author', 'date', 'image', 'videoUrl', 'audioUrl', 'sentiment', 'mediaType', 'contentType'];

        allowedFields.forEach(key => {
          if (articleToSave[key] !== undefined && articleToSave[key] !== null && articleToSave[key] !== '') {
            formDataToSend.append(key, articleToSave[key]);
          }
        });

        // Adicionar conteúdo final (texto puro ou JSON string)
        formDataToSend.append('content', finalContent);

        // Se tiver thumbnail base64 (selecionada manualmente), converter para arquivo
        if (articleToSave.thumbnailIsBase64 && articleToSave.thumbnail) {
          try {
            // Converter base64 para Blob
            const base64Data = articleToSave.thumbnail;
            const byteString = atob(base64Data.split(',')[1]);
            const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            const thumbnailFile = new File([blob], 'thumbnail.jpg', { type: mimeString });
            formDataToSend.append('thumbnail', thumbnailFile);
            console.log('🖼️ Thumbnail convertida para arquivo:', thumbnailFile.size, 'bytes');
          } catch (err) {
            console.warn('⚠️ Erro ao converter thumbnail base64 para arquivo:', err);
          }
        } else if (articleToSave.thumbnail && !articleToSave.thumbnail.startsWith('data:')) {
          // Se for uma URL (não base64), enviar como texto
          formDataToSend.append('thumbnail', articleToSave.thumbnail);
        }

        // Se tiver área de recorte (OCR), enviar como JSON
        console.log('📐 [DEBUG] Verificando cropArea no momento de salvar:', {
          cropArea: articleToSave.cropArea,
          temCropArea: !!articleToSave.cropArea
        });
        if (articleToSave.cropArea) {
          formDataToSend.append('cropArea', JSON.stringify(articleToSave.cropArea));
          console.log('📐 [DEBUG] cropArea adicionado ao FormData:', JSON.stringify(articleToSave.cropArea));
        }

        // ✅ Adicionar array de marcadores completo (OCR e Destaques)
        if (articleToSave.markers && articleToSave.markers.length > 0) {
          formDataToSend.append('markers', JSON.stringify(articleToSave.markers));
          console.log('📐 [DEBUG] markers (array) adicionado ao FormData:', JSON.stringify(articleToSave.markers));
        }

        // ✅ Adicionar tags ao FormData (como JSON string)
        if (articleToSave.tags && articleToSave.tags.length > 0) {
          formDataToSend.append('tags', JSON.stringify(articleToSave.tags));
          console.log('🏷️ Tags adicionadas ao FormData:', JSON.stringify(articleToSave.tags));
        }

        // ✅ Adicionar mídias secundárias ao FormData (como JSON string)
        if (articleToSave.allImages && articleToSave.allImages.length > 0) {
          formDataToSend.append('allImages', JSON.stringify(articleToSave.allImages));
          console.log('📸 allImages adicionadas ao FormData:', JSON.stringify(articleToSave.allImages));
        }

        if (articleToSave.carouselMedia && articleToSave.carouselMedia.length > 0) {
          formDataToSend.append('carouselMedia', JSON.stringify(articleToSave.carouselMedia));
          console.log('🎠 carouselMedia adicionadas ao FormData:', JSON.stringify(articleToSave.carouselMedia));
        }

        // Garantir que mediaType e contentType são sempre enviados
        // Mesmo se forem vazios no editedArticle, usar valores default
        if (!formDataToSend.has('mediaType')) {
          formDataToSend.append('mediaType', editedArticle.mediaType || 'Online');
          console.log('⚠️ mediaType não estava no FormData, adicionado manualmente:', editedArticle.mediaType || 'Online');
        }
        if (!formDataToSend.has('contentType')) {
          formDataToSend.append('contentType', editedArticle.contentType || 'article');
        }

        // Upload normal de arquivo (primeira página ou arquivo único)
        formDataToSend.append('media', selectedFile);

        // Enviar páginas adicionais para mídia impressa (Jornal/Revista)
        if (isPrintMedia && pages.length > 1) {
          // Enviar arquivos das páginas adicionais (a partir da página 2)
          // Páginas que vieram de URL não têm arquivo, só cloudinaryUrl
          let filesCount = 0;
          for (let i = 1; i < pages.length; i++) {
            if (pages[i].file && !pages[i].fromUrl) {
              formDataToSend.append('additionalPages', pages[i].file);
              filesCount++;
            }
          }

          // Enviar metadados das páginas (cropArea, cloudinaryUrl para páginas de URL, etc)
          const pagesMetadata = pages.map((page, index) => ({
            pageNumber: index + 1,
            cropArea: page.cropArea,
            markers: page.markers || [],
            ocrText: page.ocrText,
            thumbnail: page.thumbnail,
            // Incluir cloudinaryUrl para páginas que já estão no Cloudinary (vieram de URL)
            cloudinaryUrl: page.fromUrl ? (page.storedUrl || page.cloudinaryUrl) : null
          }));
          formDataToSend.append('pagesMetadata', JSON.stringify(pagesMetadata));
          console.log('📄 Páginas adicionais:', pages.length - 1, `(${filesCount} arquivos, ${pages.length - 1 - filesCount} URLs)`);
        }

        // Log detalhado para debug
        console.log('📤 ======== DEBUG UPLOAD ========');
        console.log('📤 Arquivo:', selectedFile.name, 'Tipo:', fileType);
        console.log('📤 editedArticle completo:', JSON.stringify(editedArticle, null, 2));
        console.log('📤 mediaType no editedArticle:', editedArticle.mediaType, '(tipo:', typeof editedArticle.mediaType, ')');
        console.log('📤 contentType no editedArticle:', editedArticle.contentType);
        console.log('📤 FormData entries:');
        for (let [key, value] of formDataToSend.entries()) {
          if (key !== 'media') {
            console.log(`   ${key}: ${value}`);
          }
        }
        console.log('📤 ================================');


        if (mode === 'create') {
          response = await api.post('/articles/upload', formDataToSend, {
            // NÃO setar Content-Type manualmente - o browser adiciona o boundary automaticamente
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            }
          });
        } else {
          // Modo edit com upload
          response = await api.put(`/articles/${editedArticle._id}/upload`, formDataToSend, {
            // NÃO setar Content-Type manualmente - o browser adiciona o boundary automaticamente
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            }
          });
        }

        if (onSave) {
          onSave(response.data.data);
        }
        if (mode === 'create') {
          window.dispatchEvent(new CustomEvent('refresh-usage-counter'));
        }
        onClose();
      } else {
        // Sem upload
        if (mode === 'create') {
          if (!articleToSave.content?.trim()) {
            setError('O conteúdo é obrigatório quando não há mídia');
            setLoading(false);
            return;
          }
          // Converter texto plano para Array JSON antes de salvar
          const articleData = {
            ...articleToSave,
            content: plainTextToContent(articleToSave.content)
          };
          response = await api.post('/articles', articleData);
          if (onSave) {
            onSave(response.data.data);
          }
          window.dispatchEvent(new CustomEvent('refresh-usage-counter'));
          onClose();
        } else {
          // Modo edição sem upload - converter texto plano para Array JSON
          // Preservar blocos de imagem originais
          const articleData = {
            ...articleToSave,
            content: plainTextToContent(articleToSave.content, originalImageBlocks),
            ...(isPrintMedia && pages.length > 0 ? {
              pages: buildPrintPagesPayload(articleToSave.image, articleToSave.thumbnail)
            } : {})
          };
          onSave(articleData);
        }
      }
    } catch (err) {
      console.error('Erro ao salvar artigo:', err);
      setError(err.response?.data?.message || 'Erro ao salvar artigo');
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  // Só renderiza se temos dados ou estamos no fluxo correto
  if (!editedArticle) {
    // No modo create, só renderiza se estamos mostrando o seletor
    if (mode === 'create' && showMediaTypeSelector) {
      // OK, pode renderizar o seletor
    } else {
      return null;
    }
  }

  return (
    <>
      {/* Seletor intermediário de tipo de mídia - só renderiza no modo create */}
      {mode === 'create' && showMediaTypeSelector && (
        <MediaTypeSelector
          open={showMediaTypeSelector}
          onClose={handleMediaTypeCancel}
          onConfirm={handleMediaTypeConfirm}
          mode="create"
        />
      )}

      {/* Modal principal de edição - só renderiza quando temos dados */}
      {editedArticle && mainModalOpen && (
        <PlatformDialog
          open={mainModalOpen}
          onClose={onClose}
          maxWidth="md"
          fullWidth
          scroll="paper"
          aria-labelledby="edit-article-dialog-title"
        >
          <PlatformDialogTitle
            id="edit-article-dialog-title"
            title={mode === 'create' ? (isMobile ? 'Novo Artigo' : 'Criar Novo Artigo') : (isMobile ? 'Editar' : 'Editar Artigo')}
            subtitle={editedArticle?.mediaType ? `${editedArticle.mediaType}${editedArticle.contentType ? ` - ${editedArticle.contentType}` : ''}` : undefined}
            onClose={onClose}
            icon={<ArticleIcon />}
          />
          <DialogContent sx={{ px: isMobile ? 2 : 3, py: isMobile ? 2 : 3, pt: isMobile ? 2 : 3.5 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
                {error}
              </Alert>
            )}

            {loading && uploadProgress > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Enviando arquivo... {uploadProgress}%
                </Typography>
                <LinearProgress variant="determinate" value={uploadProgress} />
              </Box>
            )}

            <Grid container spacing={isMobile ? 1 : 2}>
              {/* Upload de mídia - disponível em create e edit */}
              <Grid item xs={12}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: isMobile ? 1.5 : 2,
                    textAlign: 'center',
                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[50],
                    borderStyle: 'dashed',
                    borderWidth: 2,
                    borderColor: selectedFile ? theme.palette.success.main : (theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[300])
                  }}
                >
                  {!selectedFile ? (
                    <>
                      <input
                        accept="image/*,video/*,audio/*,.pdf,application/pdf"
                        style={{ display: 'none' }}
                        id="article-media-file-input"
                        type="file"
                        onChange={handleFileSelect}
                        disabled={loading}
                      />
                      <label htmlFor="article-media-file-input">
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={<UploadIcon />}
                          disabled={loading}
                          size="small"
                        >
                          {mode === 'create' ? 'Upload de Mídia (Opcional)' : 'Adicionar/Substituir Mídia'}
                        </Button>
                      </label>
                      <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>
                        Imagens, Vídeos, Áudio ou PDF • Máx: 100MB
                      </Typography>

                      {/* Campo para carregar imagem de URL - apenas para Jornal/Revista */}
                      {(editedArticle?.mediaType === 'Jornal' || editedArticle?.mediaType === 'Revista') && (
                        <Box sx={{ mt: 2, pt: 2, borderTop: '1px dashed', borderColor: 'divider' }}>
                          <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 1 }}>
                            Ou cole o link de uma imagem:
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                            <TextField
                              size="small"
                              placeholder="https://exemplo.com/imagem.jpg"
                              value={imageUrlInput}
                              onChange={(e) => setImageUrlInput(e.target.value)}
                              disabled={urlLoading || loading}
                              sx={{ minWidth: 280 }}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                  handleLoadFromUrl();
                                }
                              }}
                            />
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleLoadFromUrl}
                              disabled={urlLoading || loading || !imageUrlInput.trim()}
                              startIcon={urlLoading ? <CircularProgress size={16} /> : <UploadIcon />}
                            >
                              {urlLoading ? 'Carregando...' : 'Carregar'}
                            </Button>
                          </Box>
                        </Box>
                      )}
                      {mode === 'edit' && (editedArticle?.image || editedArticle?.videoUrl || editedArticle?.audioUrl) && (
                        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="caption" display="block" color="success.main">
                            ✓ Artigo já possui mídia.
                          </Typography>
                          {isPrintMedia && editedArticle?.image && (
                            <>
                              <Box
                                component="img"
                                src={activePrintImage}
                                alt={`Página ${currentPageIndex + 1}`}
                                sx={{
                                  maxWidth: '100%',
                                  maxHeight: 180,
                                  objectFit: 'contain',
                                  borderRadius: 1,
                                  mt: 1
                                }}
                              />
                              {pages.length > 0 && (
                                <Box sx={{ width: '100%', mt: 1.5 }}>
                                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                    Páginas ({pages.length})
                                  </Typography>
                                  <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', py: 1, px: 0.5 }}>
                                    {pages.map((page, index) => (
                                      <Box
                                        key={`${page.pageNumber || index + 1}-${getStoredPageUrl(page)}`}
                                        onClick={() => setCurrentPageIndex(index)}
                                        sx={{
                                          position: 'relative',
                                          flex: '0 0 auto',
                                          border: '2px solid',
                                          borderColor: currentPageIndex === index ? 'primary.main' : 'divider',
                                          borderRadius: 1,
                                          p: 0.5,
                                          cursor: 'pointer',
                                          bgcolor: currentPageIndex === index ? 'action.selected' : 'transparent',
                                          '&:hover': { borderColor: 'primary.light' }
                                        }}
                                      >
                                        <Box
                                          component="img"
                                          src={getStoredPageUrl(page)}
                                          alt={`Página ${page.pageNumber || index + 1}`}
                                          sx={{ width: 60, height: 80, objectFit: 'cover', borderRadius: 0.5, display: 'block' }}
                                        />
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            position: 'absolute',
                                            bottom: 2,
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            bgcolor: currentPageIndex === index ? 'primary.main' : 'grey.700',
                                            color: 'white',
                                            px: 0.5,
                                            borderRadius: 0.5,
                                            fontSize: '0.65rem'
                                          }}
                                        >
                                          {page.pageNumber || index + 1}
                                        </Typography>
                                        {(page.markers?.length > 0 || page.cropArea) && (
                                          <Box
                                            title="Página com área marcada"
                                            sx={{
                                              position: 'absolute',
                                              top: 2,
                                              left: 2,
                                              width: 12,
                                              height: 12,
                                              borderRadius: '50%',
                                              bgcolor: 'success.main'
                                            }}
                                          />
                                        )}
                                      </Box>
                                    ))}
                                  </Box>
                                  {pages.length > 1 && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                      <IconButton size="small" onClick={handlePrevPage} disabled={currentPageIndex === 0}>
                                        <PrevIcon />
                                      </IconButton>
                                      <Typography variant="body2">
                                        Página {currentPageIndex + 1} de {pages.length}
                                      </Typography>
                                      <IconButton size="small" onClick={handleNextPage} disabled={currentPageIndex === pages.length - 1}>
                                        <NextIcon />
                                      </IconButton>
                                    </Box>
                                  )}
                                </Box>
                              )}
                              <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={handleOcrExtract}
                                  disabled={ocrLoading || loading}
                                  startIcon={ocrLoading ? <CircularProgress size={16} /> : <OcrIcon />}
                                >
                                  {ocrLoading ? 'Extraindo texto...' : 'Editar Ãreas / OCR'}
                                </Button>
                                {printPageImages.length > 1 && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleAllPagesOcrExtract}
                                    disabled={ocrLoading || loading}
                                    startIcon={ocrLoading ? <CircularProgress size={16} /> : <OcrIcon />}
                                  >
                                    Todas as p�ginas (OCR)
                                  </Button>
                                )}
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={handleThumbnailSelect}
                                  disabled={loading}
                                  startIcon={<ImageIcon />}
                                  color={thumbnailPreview || editedArticle?.thumbnail ? 'success' : 'primary'}
                                >
                                  {thumbnailPreview || editedArticle?.thumbnail ? 'Editar Thumbnail' : 'Selecionar Thumbnail'}
                                </Button>
                              </Box>
                              {(thumbnailPreview || editedArticle?.thumbnail) && (
                                <Box sx={{ mt: 1, textAlign: 'center' }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                    Thumbnail atual:
                                  </Typography>
                                  <Box
                                    component="img"
                                    src={thumbnailPreview || editedArticle.thumbnail}
                                    alt="Thumbnail atual"
                                    sx={{
                                      maxWidth: 150,
                                      maxHeight: 100,
                                      objectFit: 'contain',
                                      borderRadius: 1,
                                      border: '2px solid',
                                      borderColor: 'success.main'
                                    }}
                                  />
                                </Box>
                              )}
                            </>
                          )}
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={handleClearImage}
                            sx={{ mt: 0.5 }}
                          >
                            Remover Mídia Atual
                          </Button>
                        </Box>
                      )}
                    </>
                  ) : (
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
                        {fileType === 'image' && <ImageIcon color="primary" fontSize="small" />}
                        {fileType === 'video' && <VideoIcon color="primary" fontSize="small" />}
                        {fileType === 'audio' && <AudioIcon color="primary" fontSize="small" />}
                        {fileType === 'pdf' && <PdfIcon color="error" fontSize="small" />}
                        <Typography variant="body2">
                          {selectedFile.name}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={handleRemoveFile}
                          color="error"
                          disabled={loading}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                      </Box>

                      {/* Preview para imagens e PDFs */}
                      {(fileType === 'image' || fileType === 'pdf') && filePreview && (
                        <Box
                          component="img"
                          src={filePreview}
                          alt="Preview"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: 200,
                            objectFit: 'contain',
                            borderRadius: 1
                          }}
                        />
                      )}

                      {/* Mensagem para PDF de Jornal/Revista */}
                      {fileType === 'pdf' && filePreview && (editedArticle?.mediaType === 'Jornal' || editedArticle?.mediaType === 'Revista') && (
                        <Alert severity="info" sx={{ mt: 1, textAlign: 'left' }}>
                          O texto do PDF será extraído automaticamente. Selecione a área da matéria abaixo.
                        </Alert>
                      )}

                      {/* Botões para Jornal/Revista (imagem ou PDF) */}
                      {(fileType === 'image' || fileType === 'pdf') && filePreview &&
                        (editedArticle?.mediaType === 'Jornal' || editedArticle?.mediaType === 'Revista') && (
                          <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={handleOcrExtract}
                              disabled={ocrLoading || loading}
                              startIcon={ocrLoading ? <CircularProgress size={16} /> : <OcrIcon />}
                            >
                              {ocrLoading ? 'Extraindo texto...' : 'Selecionar Área e Extrair (OCR)'}
                            </Button>
                            {printPageImages.length > 1 && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={handleAllPagesOcrExtract}
                                disabled={ocrLoading || loading}
                                startIcon={ocrLoading ? <CircularProgress size={16} /> : <OcrIcon />}
                              >
                                Todas as p�ginas (OCR)
                              </Button>
                            )}
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={handleThumbnailSelect}
                              disabled={loading}
                              startIcon={<ImageIcon />}
                              color={thumbnailPreview ? 'success' : 'primary'}
                            >
                              {thumbnailPreview ? 'Thumbnail Selecionada ✓' : 'Selecionar Thumbnail'}
                            </Button>
                          </Box>
                        )}

                      {/* Preview da thumbnail selecionada */}
                      {thumbnailPreview && (editedArticle?.mediaType === 'Jornal' || editedArticle?.mediaType === 'Revista') && (
                        <Box sx={{ mt: 1, textAlign: 'center' }}>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                            Thumbnail selecionada:
                          </Typography>
                          <Box
                            component="img"
                            src={thumbnailPreview}
                            alt="Thumbnail Preview"
                            sx={{
                              maxWidth: 150,
                              maxHeight: 100,
                              objectFit: 'contain',
                              borderRadius: 1,
                              border: '2px solid',
                              borderColor: 'success.main'
                            }}
                          />
                        </Box>
                      )}

                      {/* Interface de múltiplas páginas para Jornal/Revista */}
                      {isPrintMedia && (filePreview || pages.length > 0) && (
                        <Box sx={{ mt: 2, p: 1, bgcolor: 'background.default', borderRadius: 1 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ArticleIcon fontSize="small" />
                            Páginas ({pages.length > 0 ? pages.length : 1})
                          </Typography>

                          {/* Lista de miniaturas das páginas */}
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center', mb: 1 }}>
                            {pages.length === 0 && filePreview && (
                              <Box
                                sx={{
                                  position: 'relative',
                                  border: '2px solid',
                                  borderColor: 'primary.main',
                                  borderRadius: 1,
                                  p: 0.5
                                }}
                              >
                                <Box
                                  component="img"
                                  src={filePreview}
                                  alt="Página 1"
                                  sx={{ width: 60, height: 80, objectFit: 'cover', borderRadius: 0.5 }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 2,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    bgcolor: 'primary.main',
                                    color: 'white',
                                    px: 0.5,
                                    borderRadius: 0.5,
                                    fontSize: '0.65rem'
                                  }}
                                >
                                  1
                                </Typography>
                              </Box>
                            )}

                            {pages.map((page, index) => (
                              <Box
                                key={index}
                                onClick={() => setCurrentPageIndex(index)}
                                sx={{
                                  position: 'relative',
                                  border: '2px solid',
                                  borderColor: currentPageIndex === index ? 'primary.main' : 'divider',
                                  borderRadius: 1,
                                  p: 0.5,
                                  cursor: 'pointer',
                                  '&:hover': { borderColor: 'primary.light' }
                                }}
                              >
                                <Box
                                  component="img"
                                  src={page.preview}
                                  alt={`Página ${page.pageNumber}`}
                                  sx={{ width: 60, height: 80, objectFit: 'cover', borderRadius: 0.5 }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 2,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    bgcolor: currentPageIndex === index ? 'primary.main' : 'grey.600',
                                    color: 'white',
                                    px: 0.5,
                                    borderRadius: 0.5,
                                    fontSize: '0.65rem'
                                  }}
                                >
                                  {page.pageNumber}
                                </Typography>
                                {/* Botão de remover página */}
                                <IconButton
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); handleRemovePage(index); }}
                                  sx={{
                                    position: 'absolute',
                                    top: -8,
                                    right: -8,
                                    bgcolor: 'error.main',
                                    color: 'white',
                                    width: 18,
                                    height: 18,
                                    '&:hover': { bgcolor: 'error.dark' }
                                  }}
                                >
                                  <CloseIcon sx={{ fontSize: 12 }} />
                                </IconButton>
                                {/* Indicador de OCR extraído */}
                                {page.cropArea && (
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      top: 2,
                                      left: 2,
                                      bgcolor: 'success.main',
                                      borderRadius: '50%',
                                      width: 14,
                                      height: 14,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <OcrIcon sx={{ fontSize: 10, color: 'white' }} />
                                  </Box>
                                )}
                              </Box>
                            ))}

                            {/* Botão para adicionar mais páginas */}
                            <Box
                              component="label"
                              sx={{
                                width: 60,
                                height: 80,
                                border: '2px dashed',
                                borderColor: 'divider',
                                borderRadius: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' }
                              }}
                            >
                              <AddPageIcon fontSize="small" color="action" />
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                + Página
                              </Typography>
                              <input
                                type="file"
                                hidden
                                accept="image/*,application/pdf"
                                onChange={handleAddPage}
                              />
                            </Box>
                          </Box>

                          {/* Navegação de páginas */}
                          {pages.length > 1 && (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                              <IconButton
                                size="small"
                                onClick={handlePrevPage}
                                disabled={currentPageIndex === 0}
                              >
                                <PrevIcon />
                              </IconButton>
                              <Typography variant="body2">
                                Página {currentPageIndex + 1} de {pages.length}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={handleNextPage}
                                disabled={currentPageIndex === pages.length - 1}
                              >
                                <NextIcon />
                              </IconButton>
                            </Box>
                          )}

                          {/* Campo para adicionar páginas via URL (suporta múltiplas) */}
                          <Box sx={{ mt: 1.5 }}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                              <TextField
                                size="small"
                                multiline
                                minRows={1}
                                maxRows={4}
                                placeholder="Cole uma ou mais URLs (uma por linha)"
                                value={pageUrlInput}
                                onChange={(e) => setPageUrlInput(e.target.value)}
                                disabled={pageUrlLoading || loading}
                                sx={{ flex: 1 }}
                              />
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={handleAddPageFromUrl}
                                disabled={pageUrlLoading || loading || !pageUrlInput.trim()}
                                startIcon={pageUrlLoading ? <CircularProgress size={14} /> : <AddPageIcon />}
                                sx={{ minWidth: 100, height: 40 }}
                              >
                                {pageUrlLoading ? 'Carregando...' : '+ URLs'}
                              </Button>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 0.5 }}>
                              Cole múltiplas URLs separadas por linha, vírgula ou espaço
                            </Typography>
                          </Box>
                        </Box>
                      )}

                      {fileType === 'video' && filePreview && (
                        <Box
                          component="video"
                          src={filePreview}
                          controls
                          sx={{
                            maxWidth: '100%',
                            maxHeight: 200,
                            borderRadius: 1
                          }}
                        />
                      )}

                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                        {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                      </Typography>
                    </Box>
                  )}
                </Paper>
              </Grid>

              {/* Galeria de Mídias (allImages, carouselMedia e imagens de conteúdo) */}
              {((editedArticle?.allImages && editedArticle.allImages.length > 0) ||
                (editedArticle?.carouselMedia && editedArticle.carouselMedia.length > 0) ||
                (originalImageBlocks && originalImageBlocks.length > 0)) && (
                  <Grid item xs={12}>
                    <Box sx={{ mb: 2, p: 2, bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
                      <Typography variant="subtitle2" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                        <ImageIcon fontSize="small" color="primary" />
                        Galeria de Mídias (Capturada automaticamente)
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1.5,
                          overflowX: 'auto',
                          pb: 1,
                          px: 0.5,
                          '&::-webkit-scrollbar': { height: 6 },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'divider',
                            borderRadius: 4
                          }
                        }}
                      >
                        {/* 1. Renderizar imagens do conteúdo (originalImageBlocks) */}
                        {originalImageBlocks?.map((block, index) => (
                          <Box
                            key={`contentimg-${index}`}
                            sx={{
                              position: 'relative',
                              minWidth: 100,
                              maxWidth: 100,
                              height: 100,
                              borderRadius: 1.5,
                              overflow: 'hidden',
                              border: '1px solid',
                              borderColor: 'divider',
                              flexShrink: 0,
                              transition: 'transform 0.2s',
                              '&:hover': { transform: 'scale(0.98)' }
                            }}
                          >
                            <Box
                              component="img"
                              src={block.src}
                              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=Error'; }}
                            />
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveContentImage(index)}
                              sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                bgcolor: 'rgba(255, 255, 255, 0.9)',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                padding: '2px',
                                '&:hover': { bgcolor: 'error.main', color: 'white' }
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Box>
                        ))}

                        {/* 2. Renderizar allImages */}
                        {editedArticle?.allImages?.map((img, index) => (
                          <Box
                            key={`allimg-${index}`}
                            sx={{
                              position: 'relative',
                              minWidth: 100,
                              maxWidth: 100,
                              height: 100,
                              borderRadius: 1.5,
                              overflow: 'hidden',
                              border: '1px solid',
                              borderColor: 'divider',
                              flexShrink: 0,
                              transition: 'transform 0.2s',
                              '&:hover': { transform: 'scale(0.98)' }
                            }}
                          >
                            <Box
                              component="img"
                              src={img}
                              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=Error'; }}
                            />
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveAllImage(index)}
                              sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                bgcolor: 'rgba(255, 255, 255, 0.9)',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                padding: '2px',
                                '&:hover': { bgcolor: 'error.main', color: 'white' }
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Box>
                        ))}

                        {/* 3. Renderizar carouselMedia */}
                        {editedArticle?.carouselMedia?.map((item, index) => (
                          <Box
                            key={`carousel-${index}`}
                            sx={{
                              position: 'relative',
                              minWidth: 100,
                              maxWidth: 100,
                              height: 100,
                              borderRadius: 1.5,
                              overflow: 'hidden',
                              border: '1px solid',
                              borderColor: 'divider',
                              flexShrink: 0,
                              bgcolor: 'black',
                              transition: 'transform 0.2s',
                              '&:hover': { transform: 'scale(0.98)' }
                            }}
                          >
                            {item.type === 'video' ? (
                              <Box
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  background: 'linear-gradient(45deg, #000, #333)'
                                }}
                              >
                                <VideoIcon sx={{ color: 'white' }} />
                                <Typography variant="caption" sx={{ position: 'absolute', bottom: 4, color: 'white', fontSize: '0.6rem', fontWeight: 700 }}>VÍDEO</Typography>
                              </Box>
                            ) : (
                              <Box
                                component="img"
                                src={item.src || item.url}
                                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=Error'; }}
                              />
                            )}
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveCarouselMedia(index)}
                              sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                bgcolor: 'rgba(255, 255, 255, 0.9)',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                padding: '2px',
                                '&:hover': { bgcolor: 'error.main', color: 'white' }
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Box>
                        ))}
                      </Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}>
                        Clique no ícone de lixeira para remover mídias capturadas individualmente.
                      </Typography>
                    </Box>
                  </Grid>
                )}

              <Grid item xs={12}>
                <TextField
                  name="title"
                  label="Título *"
                  fullWidth
                  value={editedArticle.title}
                  onChange={handleChange('title')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                  required
                  disabled={loading}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="siteName"
                  label="Nome do Site"
                  fullWidth
                  value={editedArticle.siteName}
                  onChange={handleChange('siteName')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="siteUrl"
                  label="URL do Site"
                  fullWidth
                  value={editedArticle.siteUrl}
                  onChange={handleChange('siteUrl')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                  InputProps={{
                    endAdornment: (editedArticle.mediaType === 'Online' && mode === 'create') ? (
                      <InputAdornment position="end">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={handleSmartScrape}
                          disabled={isSmartScraping || !editedArticle.siteUrl}
                          sx={{ 
                            textTransform: 'none', 
                            borderRadius: '20px',
                            minWidth: 'auto',
                            px: 2,
                            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                            boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                            '&:hover': {
                              background: 'linear-gradient(45deg, #1976D2 30%, #00BCD4 90%)',
                            }
                          }}
                        >
                          {isSmartScraping ? <CircularProgress size={20} color="inherit" /> : '✨ Extrair via IA'}
                        </Button>
                      </InputAdornment>
                    ) : null
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="author"
                  label="Autor"
                  fullWidth
                  value={editedArticle.author}
                  onChange={handleChange('author')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    label="Data"
                    value={editedArticle.date ? new Date(editedArticle.date) : null}
                    views={['year', 'month', 'day']}
                    openTo="day"
                    yearsPerRow={4}
                    monthsPerRow={3}
                    slots={{ calendarHeader: DatePickerCalendarHeader }}
                    onChange={(newValue) => {
                      if (newValue && !isNaN(newValue.getTime())) {
                        const year = newValue.getFullYear();
                        const month = String(newValue.getMonth() + 1).padStart(2, '0');
                        const day = String(newValue.getDate()).padStart(2, '0');
                        setEditedArticle(prev => ({
                          ...prev,
                          date: `${year}-${month}-${day}T12:00:00.000Z`
                        }));
                      } else {
                        setEditedArticle(prev => ({ ...prev, date: '' }));
                      }
                    }}
                    format="dd/MM/yyyy"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        margin: isMobile ? 'dense' : 'normal',
                        size: isMobile ? 'small' : 'medium'
                      },
                      day: {
                        sx: {
                          '&.Mui-selected': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            '&:hover': {
                              backgroundColor: theme.palette.primary.dark,
                            }
                          }
                        }
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="image"
                  label="URL da Imagem"
                  fullWidth
                  value={editedArticle.image || ''}
                  onChange={handleChange('image')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                  placeholder="https://exemplo.com/imagem.jpg"
                  InputProps={{
                    endAdornment: (editedArticle.image || selectedFile) && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="remover imagem"
                          onClick={handleClearImage}
                          edge="end"
                          size="small"
                          color="error"
                          title="Remover Imagem"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="description"
                  label="Descrição"
                  fullWidth
                  value={editedArticle.description}
                  onChange={handleChange('description')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                  multiline
                  rows={isMobile ? 1 : 2}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="content"
                  label="Conteúdo"
                  fullWidth
                  value={editedArticle.content}
                  onChange={handleChange('content')}
                  margin={isMobile ? 'dense' : 'normal'}
                  size={isMobile ? 'small' : 'medium'}
                  multiline
                  rows={isMobile ? 4 : 8}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth margin={isMobile ? 'dense' : 'normal'} size={isMobile ? 'small' : 'medium'}>
                  <InputLabel id="sentiment-label">Sentimento</InputLabel>
                  <Select
                    labelId="sentiment-label"
                    name="sentiment"
                    value={editedArticle.sentiment}
                    onChange={handleChange('sentiment')}
                    label="Sentimento"
                  >
                    <MenuItem value="positive">Positivo</MenuItem>
                    <MenuItem value="neutral">Neutro</MenuItem>
                    <MenuItem value="negative">Negativo</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin={isMobile ? 'dense' : 'normal'} size={isMobile ? 'small' : 'medium'}>
                  <InputLabel id="mediaType-label">Plataforma</InputLabel>
                  <Select
                    labelId="mediaType-label"
                    name="mediaType"
                    value={editedArticle.mediaType || 'Online'}
                    onChange={handleMediaTypeChange}
                    label="Plataforma"
                  >
                    {/* Mídias Digitais */}
                    <MenuItem value="Online"><ListItemIcon sx={{ minWidth: 32 }}><WebIcon fontSize="small" /></ListItemIcon>Online (Site)</MenuItem>
                    <MenuItem value="YouTube"><ListItemIcon sx={{ minWidth: 32 }}><YouTubeIcon fontSize="small" /></ListItemIcon>YouTube</MenuItem>
                    <MenuItem value="Twitter"><ListItemIcon sx={{ minWidth: 32 }}><XIcon fontSize="small" /></ListItemIcon>Twitter/X</MenuItem>
                    <MenuItem value="Instagram"><ListItemIcon sx={{ minWidth: 32 }}><InstagramIcon fontSize="small" /></ListItemIcon>Instagram</MenuItem>
                    <MenuItem value="Threads"><ListItemIcon sx={{ minWidth: 32 }}><ThreadsIcon fontSize="small" /></ListItemIcon>Threads</MenuItem>
                    <MenuItem value="TikTok"><ListItemIcon sx={{ minWidth: 32 }}><TikTokIcon fontSize="small" /></ListItemIcon>TikTok</MenuItem>
                    <MenuItem value="Facebook"><ListItemIcon sx={{ minWidth: 32 }}><FacebookIcon fontSize="small" /></ListItemIcon>Facebook</MenuItem>
                    <MenuItem value="LinkedIn"><ListItemIcon sx={{ minWidth: 32 }}><LinkedInIcon fontSize="small" /></ListItemIcon>LinkedIn</MenuItem>
                    <MenuItem value="Pinterest"><ListItemIcon sx={{ minWidth: 32 }}><PinterestIcon fontSize="small" /></ListItemIcon>Pinterest</MenuItem>
                    {/* Mídias Impressas */}
                    <MenuItem value="Jornal"><ListItemIcon sx={{ minWidth: 32 }}><NewspaperIcon fontSize="small" /></ListItemIcon>Jornal</MenuItem>
                    <MenuItem value="Revista"><ListItemIcon sx={{ minWidth: 32 }}><MagazineIcon fontSize="small" /></ListItemIcon>Revista</MenuItem>
                    {/* Mídias Eletrônicas */}
                    <MenuItem value="TV"><ListItemIcon sx={{ minWidth: 32 }}><TvIcon fontSize="small" /></ListItemIcon>TV</MenuItem>
                    <MenuItem value="Radio"><ListItemIcon sx={{ minWidth: 32 }}><RadioIcon fontSize="small" /></ListItemIcon>Rádio</MenuItem>
                    <MenuItem value="Podcast"><ListItemIcon sx={{ minWidth: 32 }}><PodcastIcon fontSize="small" /></ListItemIcon>Podcast</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin={isMobile ? 'dense' : 'normal'} size={isMobile ? 'small' : 'medium'}>
                  <InputLabel id="contentType-label">Formato</InputLabel>
                  <Select
                    labelId="contentType-label"
                    name="contentType"
                    value={editedArticle.contentType || 'article'}
                    onChange={handleChange('contentType')}
                    label="Formato"
                  >
                    {getContentTypeOptions(editedArticle.mediaType || 'Online').map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant={isMobile ? 'body2' : 'subtitle1'} gutterBottom>
                  Tags
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: isMobile ? 0.5 : 1 }}>
                  {editedArticle.tags?.map(tag => (
                    <TagChip
                      key={tag._id}
                      label={tag.name || (availableTags.find(t => t._id === tag._id)?.name) || tag._id}
                      onDelete={() => handleRemoveTag(tag._id)}
                      color="primary"
                      variant="outlined"
                      fontSize={customFontSize}
                      size={isMobile ? 'small' : 'medium'}
                    />
                  ))}
                  <TagChip
                    icon={<AddIcon />}
                    label={isMobile ? 'Tag' : 'Adicionar Tag'}
                    onClick={() => setAddTagsDialogOpen(true)}
                    color="primary"
                    variant="outlined"
                    fontSize={customFontSize}
                    size={isMobile ? 'small' : 'medium'}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1.5, flexDirection: 'column', alignItems: 'stretch' }}>
            {/* Mensagem de feedback do re-scrape */}
            {rescrapeMessage && (
              <Alert
                severity={rescrapeMessage.type}
                onClose={() => setRescrapeMessage(null)}
                sx={{ width: '100%', mb: 1 }}
              >
                {rescrapeMessage.text}
              </Alert>
            )}
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
              <Box sx={{ flex: 1, display: 'flex', gap: 1 }}>
                {mode === 'edit' && !rescraping && editedArticle?.mediaType === 'Online' && editedArticle?.siteUrl && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleRescrape}
                    startIcon={<RefreshIcon />}
                    disabled={loading}
                  >
                    {isMobile ? '' : 'Re-scrape'}
                  </Button>
                )}
              </Box>
              
              <Button
                onClick={onClose}
                variant="text"
                disabled={loading}
              >
                Cancelar
              </Button>
              
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={16} /> : <SaveIcon />}
              >
                {loading ? 'Salvando...' : (mode === 'create' ? 'Criar Artigo' : 'Salvar')}
              </Button>
            </Box>
          </DialogActions>
        </PlatformDialog>
      )}

      {/* Modal de tags */}
      <TagDialog
        open={addTagsDialogOpen}
        onClose={() => setAddTagsDialogOpen(false)}
        onAddTags={handleAddTags}
        availableTags={availableTags}
        currentTags={article?.tags || []}
        mode="both"
      />

      {/* Dialog de marcação de áreas (OCR e Destaques) */}
      <ImageCropDialog
        open={showCropDialog}
        onClose={() => setShowCropDialog(false)}
        imageSrc={activePrintImage}
        onCropComplete={handleCropComplete}
        title="Marcar áreas da matéria"
        initialMarkers={currentPageMarkers}
      />

      {/* Dialog de seleção de área da thumbnail (Jornal/Revista) */}
      <ImageCropDialog
        open={showThumbnailCropDialog}
        onClose={() => setShowThumbnailCropDialog(false)}
        imageSrc={activePrintImage}
        onCropComplete={handleThumbnailCropComplete}
        title="Selecione a área para thumbnail"
        mode="crop"
      />

      {/* Dialog de seleção de matérias (OCR) */}
      <PlatformDialog
        open={showArticleSelector}
        onClose={handleArticleSelectorClose}
        maxWidth="sm"
        fullWidth
      >
        <PlatformDialogTitle
          title="Selecione a Matéria"
          icon={<OcrIcon color="primary" />}
          onClose={handleArticleSelectorClose}
        />
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Foram encontradas {ocrArticles.length} matérias na página. Selecione qual você deseja importar:
          </Typography>
          <List sx={{ pt: 0 }}>
            {ocrArticles.map((article, index) => (
              <React.Fragment key={article.id || index}>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => handleArticleSelect(article)}>
                    <ListItemIcon>
                      <ArticleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={article.titulo}
                      secondary={
                        <Box component="span">
                          {article.subtitulo && (
                            <Typography variant="body2" component="span" display="block" sx={{ fontStyle: 'italic' }}>
                              {article.subtitulo}
                            </Typography>
                          )}
                          {article.autor && (
                            <Typography variant="caption" component="span" display="block" color="text.secondary">
                              Por {article.autor}
                            </Typography>
                          )}
                          {article.resumo && (
                            <Typography variant="caption" component="span" display="block" sx={{ mt: 0.5 }}>
                              {article.resumo}
                            </Typography>
                          )}
                        </Box>
                      }
                      primaryTypographyProps={{
                        fontWeight: 'bold',
                        color: 'primary'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                {index < ocrArticles.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleArticleSelectorClose} color="inherit">
            Usar Texto Completo
          </Button>
        </DialogActions>
      </PlatformDialog>
    </>
  );
};

export default ArticleEditModal;
